import { render } from "./ImportProd.vue?vue&type=template&id=86cf049a"
import script from "./ImportProd.vue?vue&type=script&lang=ts"
export * from "./ImportProd.vue?vue&type=script&lang=ts"

import "./ImportProd.vue?vue&type=style&index=0&id=86cf049a&lang=css"
script.render = render

export default script